import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { FunctionComponent } from 'react';

import {
  FolkloreType,
  UserMatchesQuery,
} from '../../../../../apollo/__generated__/graphql';
import { folkloreNameByFolklore } from '../../../../../user/services/user.service';
import { useUserMatchesQuery } from '../../../../hooks/useUserMatchesQuery';

interface UserMatchesTabProps {
  eventId: string;
}

const columns: GridColDef<UserMatchesQuery['userMatches'][number]>[] = [
  {
    field: 'firstname',
    headerName: 'Nom',
    width: 150,
    renderCell: (params) =>
      `${params.row.firstname} ${params.row.lastname?.substring(0, 1)}.`,
  },
  {
    field: 'nickname',
    headerName: 'Surnom',
    width: 150,
  },
  {
    field: 'folklore',
    headerName: 'Folklore',
    renderCell: (params) =>
      folkloreNameByFolklore[params.row.folklore ?? FolkloreType.Other],
    width: 100,
  },
  {
    field: 'studyTown',
    headerName: 'Ville',
    width: 150,
  },
  {
    field: 'hasSuperLikedMe',
    headerName: 'Super like reçu ?',
    width: 150,
    renderCell: (params) => (params.row.hasSuperLikedMe ? 'Oui' : 'Non'),
  },
];

export const UserMatchesTab: FunctionComponent<UserMatchesTabProps> = ({
  eventId,
}) => {
  const { data: userMatchesData, loading } = useUserMatchesQuery(eventId);

  return (
    <DataGrid
      rows={userMatchesData?.userMatches ?? []}
      columns={columns}
      loading={loading}
    />
  );
};
